import { render } from "./LevinsohnPropositions.vue?vue&type=template&id=744e33e1&scoped=true"
import script from "./LevinsohnPropositions.vue?vue&type=script&lang=js"
export * from "./LevinsohnPropositions.vue?vue&type=script&lang=js"

import "./LevinsohnPropositions.vue?vue&type=style&index=0&id=744e33e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744e33e1"]])

export default __exports__